var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78199 25.0662H22.4324C25.56 25.0003 25.9551 20.5888 22.9262 19.9303V3.60086C22.9262 2.1852 21.774 1 20.3254 1H3.60086C2.15228 1.03292 1 2.1852 1 3.60086C1 5.01652 2.15228 6.20172 3.56794 6.20172H5.18113V22.4653C5.21405 23.9139 6.36633 25.0662 7.78199 25.0662ZM24.0456 22.4653C24.0456 23.3542 23.3213 24.0785 22.4324 24.0785H9.82317C10.5475 23.1238 10.5475 21.8069 9.82317 20.8851H22.4653C23.3213 20.8851 24.0456 21.6094 24.0456 22.4653ZM20.3583 2.02059C21.2472 2.02059 21.9715 2.74488 21.9715 3.63378V19.8974H7.81491C7.55154 19.8974 7.32108 20.1278 7.32108 20.3912C7.32108 20.6546 7.55154 20.8851 7.81491 20.8851C8.70382 20.8851 9.42811 21.6094 9.42811 22.4983C9.36226 24.6053 6.30049 24.6382 6.23464 22.4983V3.63378C6.23464 3.13995 6.10295 2.67904 5.83958 2.28397C5.77373 2.1852 5.74081 2.11936 5.67496 2.05351H20.3583V2.02059ZM3.60086 5.21405C1.49383 5.14821 1.49383 2.08644 3.60086 2.02059C4.48976 2.02059 5.21405 2.74488 5.21405 3.63378V5.24697L3.60086 5.21405Z",
    fill: "#00A7B5",
    stroke: "#00A7B5",
    strokeWidth: 0.658446,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6873 14.4337C12.8848 14.6313 13.1811 14.6313 13.3787 14.4337L17.5598 10.2526C17.7573 10.0551 17.7573 9.75877 17.5598 9.56124C17.3623 9.3637 17.066 9.3637 16.8684 9.56124L13.0165 13.4131L11.2716 11.6683C11.0741 11.4707 10.7778 11.4707 10.5803 11.6683C10.3827 11.8658 10.3827 12.1621 10.5803 12.3596L12.6873 14.4337Z",
    fill: "#00A7B5",
    stroke: "#00A7B5",
    strokeWidth: 0.658446,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.cf6fd70166b95cfae6d7e21c76365076.svg";
export { ForwardRef as ReactComponent };